import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react"
import { FACILITIES, DEFAULT_FACILITY, FACILITY_OPTIONS, isValidFacility } from "@amzn/eclipse-ui-common/constants/facilities"

const STORAGE_KEY = "eclipse_hhu_facility"

interface FacilityContextValue {
  facility: string
  facilityName: string
  setFacility: (code: string) => void
}

const FacilityContext = createContext<FacilityContextValue>({
  facility: DEFAULT_FACILITY,
  facilityName: FACILITIES[DEFAULT_FACILITY],
  setFacility: () => {},
})

export const FacilityProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [facility, setFacilityCode] = useState<string>(() => {
    const stored = localStorage.getItem(STORAGE_KEY)
    return stored && isValidFacility(stored) ? stored : DEFAULT_FACILITY
  })

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, facility)
  }, [facility])

  const setFacility = useCallback((code: string) => {
    if (isValidFacility(code)) setFacilityCode(code)
  }, [])

  const value = useMemo<FacilityContextValue>(
    () => ({ facility, facilityName: FACILITIES[facility] ?? facility, setFacility }),
    [facility, setFacility]
  )

  return <FacilityContext.Provider value={value}>{children}</FacilityContext.Provider>
}

export const useFacility = () => useContext(FacilityContext)

export { FACILITY_OPTIONS }
